import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AlertTriangle } from "lucide-react";

const CustomTypography = styled(Typography)(() => ({
  fontFamily: "CircularRegular",
  fontStyle: "normal",
}));

const StyledContainer = styled(Box)(() => ({
  borderRadius: "14px",
  border: "1px solid var(--qv-bd-a0x0x0x100, rgba(0, 0, 0, 0.10))",
  background: "var(--qv-bg-ffffff, #FFF)",
  padding: "49px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "16px",
}));

const IconContainer = styled(Box)(() => ({
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  background: "var(--qv-bg-e1e1e1, #E1E1E1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "8px",
  "& img, & svg": {
    width: "32px",
    height: "32px",
    opacity: 0.6,
  },
}));

/**
 * Same card layout as NoEmployeesFound — used when route access is denied.
 */
function PermissionDeniedEmptyState({
  title = "Access denied",
  description = "You do not have permission to access this page.",
}) {
  return (
    <Box sx={{ p: 2, maxWidth: "100%" }}>
      <StyledContainer>
        <IconContainer>
          <AlertTriangle />
        </IconContainer>
        <CustomTypography
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "var(--qv-tx-0a0a0a, #0A0A0A)",
            marginBottom: "4px",
          }}
        >
          {title}
        </CustomTypography>
        <CustomTypography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            color: "var(--qv-tx-707070, #707070)",
            maxWidth: "400px",
          }}
        >
          {description}
        </CustomTypography>
      </StyledContainer>
    </Box>
  );
}

export default PermissionDeniedEmptyState;
